import Newsletter from "@/components/newsletter/Newsletter.vue";

export default {
  components: { Newsletter },
  data() {
    return {
      c: null,
      newsletterData: null,
    };
  },
  methods: {
    updateComponent(id) {
      import(`@/components/newsletter/${id}/index.vue`)
        .then((module) => {
          this.c = module.default;
        })
        .catch((e) => {
          console.warn(e);
          this.newsletterData = require(`@/data/newsletter/${id}.yml`);
        })
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.updateComponent(to.params.id));
  },
  beforeRouteUpdate(to, from, next) {
    this.updateComponent(to.params.id);
    next();
  },
};
